import { render, staticRenderFns } from "./ListAuthors.vue?vue&type=template&id=24f3ebf4&scoped=true&"
import script from "./ListAuthors.vue?vue&type=script&lang=js&"
export * from "./ListAuthors.vue?vue&type=script&lang=js&"
import style0 from "./ListAuthors.vue?vue&type=style&index=0&id=24f3ebf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f3ebf4",
  null
  
)

export default component.exports